import { MantineTheme } from '@mantine/core';

import { defaultActivityThemeStyles } from 'external-modules/ui/themes';
import { ActivityThemeStyles } from 'shared/types/Theme';

import { DEFAULT_THEME } from './_mantineClone/defaultTheme';
import { mergeMantineTheme } from './_mantineClone/mergeMantineTheme';
import { themeToVars } from './themeToVars';
import { theme } from '@/utils/theme.utils';

export const vars = themeToVars(
  mergeMantineTheme(DEFAULT_THEME, {
    ...theme,
    other: defaultActivityThemeStyles
  }) as MantineTheme & {
    other: ActivityThemeStyles;
  }
);
